
<form *ngIf="user.contactDetails" #userForm="ngForm" autocomplete="off" class="mt-3 pt-3">

    <div class="send-email-btn">
        <button *ngIf="
            isGrantedAny('Pages.Administration.Users.Edit') &&
            !ownDetailsEdit
        " (click)="sendEmailActivationLink()" [busyText]="l('SavingWithThreeDot')" [buttonBusy]="saving"
            class="btn btn-primary blue">
            <i class="fa fa-envelope-square"></i>
            <span>{{ l("SendEmailActivationLink") }}</span>
        </button>
    </div>
    <div class="form-group">
        <label for="Staff_EmailAddress">{{ l("EmailAddress") }}</label>
        <input type="text" id="Staff_EmailAddress" class="form-control" [disabled]="ownDetailsEdit"
            [(ngModel)]="user.contactDetails.emailAddress" name="EmailAddress" #email="ngModel"
            pattern="[A-Za-z0-9._'%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" required />
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid">
            <div *ngIf="email.errors.required">
                {{ l('EmailIsRequired') }}
            </div>
            <div *ngIf="email.errors.pattern">
                {{ l('InvalidEmail') }}
            </div>
        </div>
    </div>
    <div class="form-group">
        <label for="Staff_FirstName">{{ l("FirstName") }}</label>
        <input type="text" id="Staff_FirstName" class="form-control" [(ngModel)]="user.contactDetails.firstName"
            required #firstName="ngModel" name="FirstName" />

        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="invalid">
            <div *ngIf="firstName.errors.required">
                {{ l('FirstNameIsRequired') }}
            </div>
        </div>
    </div>

    <div class="form-group">
        <label for="Staff_LastName">{{ l("LastName") }}</label>
        <input type="text" id="Staff_LastName" class="form-control" [(ngModel)]="user.contactDetails.lastName" required
            #lastName="ngModel" name="LastName" />

        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="invalid">
            <div *ngIf="lastName.errors.required">
                {{ l('LastNameIsRequired') }}
            </div>
        </div>

    </div>

    <div class="form-group">
        <label for="Staff_JobTitle">{{ l("JobTitle") }}</label>
        <input type="text" id="Staff_JobTitle" class="form-control" [(ngModel)]="user.jobTitle" required
            #jobTitle="ngModel" name="JobTitle" />
        <div *ngIf="jobTitle.invalid && (jobTitle.dirty || jobTitle.touched)" class="invalid">
            <div *ngIf="jobTitle.errors.required">
                {{ l('JobTitleIsRequired') }}
            </div>
        </div>
    </div>
    <div class="form-group">
        <label for="Staff_Company" class="mb-0">{{ l("Company") }}</label>
        <div class="input-group">
            <mat-form-field appearance="none">
                <input type="text" id="Staff_Company" class="form-control" required name="Company" matInput
                    [formControl]="companyFormCtrl" [matAutocomplete]="auto" />
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
                        {{company}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="invalid" *ngIf="companyFormCtrl.hasError('required')"> {{ l('CompanyIsRequired')
            }}</div>
    </div>
    <div class="form-group">
        <app-user-roles [staff]="staff" (roleChanged)="loadUser()">
        </app-user-roles>
    </div>

    <div class="form-group" *ngIf="user.isUserRoleHasManager">
        <label for="UserName">{{ l("Manager") }}</label>
        <div class="input-group">
            <input class="form-control" id="UserName" name="userName" [(ngModel)]="signOffPerson" type="text"
            [required]="user.isUserRoleHasManager" />
            <div class="input-group-append">
                <button class="btn btn-primary blue"
                (click)="openSelectUserModal()"
                type="button">
                    <i class="fa fa-search"
                    data-toggle="popover"
                    data-trigger="hover"
                    data-html="true"
                    [popover]="popTemplate"
                    triggers="mouseenter:mouseleave"></i>
                    <ng-template #popTemplate>
                        <div class="tooltip-div">{{ l('SelectaManager') }}</div>
                    </ng-template>
                    {{ l("Pick") }}
                </button>
            </div>
            <div class="input-group-prepend">
                <button class="btn btn-danger btn-icon" type="button" (click)="setUserIdNull()">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
    </div>


    <ng-container>
        <div class="send-email-btn">
            <button *ngIf="!isMyProfileEdit" (click)="moveToUsers()" tabindex="5" class="btn btn btn-default">
                <span>{{l("Cancel")}}</span>
            </button>
            <button (click)="userForm.form.valid && save()" [class]="!userForm.form.valid || companyFormCtrl.hasError('required') ? 'btn btn-primary blue float-right invalidBtn' : 'btn btn-primary blue float-right'"
                [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')" [matTooltip]="!userForm.form.valid || companyFormCtrl.hasError('required') ? l('CompleteAllMissingFields') : ''">
                <i class="fa fa-save"></i>
                <span>{{ l("Save") }}</span>
            </button>
        </div>
    </ng-container>

</form>


<staffUserLookupTableModal #staffUserLookupTableModal (modalSave)="getSelectedUser()">
</staffUserLookupTableModal>
